// @flow

/**
 * Module dependencies.
 */

import { Col, Container, Row } from 'client/components/core/grid';
import { branch } from 'core/utils/branch';
import { colors, fixedHeight, media, units } from 'client/styles';
import { compose, defaultProps } from 'recompose';
import BackgroundImage from 'client/components/core/images/background-image';
import Overlay from 'client/components/header/overlay';
import React from 'react';
import Text from 'client/components/core/type';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  backgroundColor?: string,
  filename?: string,
  lead: string,
  short: boolean,
  title: string
};

/**
 * `HeaderWrapper` styled component.
 */

const HeaderWrapper = styled.div`
  background-color: ${({ background }: Object): string => background};
  min-height: 50vh;
  overflow: hidden;
  padding-bottom: 12vh;
  padding-top: calc(12vh + ${fixedHeight.navbarMobile});
  position: relative;

  ${media.landscape.sm`
    min-height: 300px;
  `}

  ${media.min.sm`
    height: 75vh;
    min-height: 500px;
    padding-bottom: ${units(12)};
    padding-top: ${units(22)};
  `}
`;

/**
 * Export `HeaderComponent`.
 */

function HeaderComponent(props: Props): React$Element<*> {
  const {
    backgroundColor,
    filename,
    lead,
    short,
    title
  } = props;

  return (
    <HeaderWrapper background={backgroundColor}>
      {branch(filename, <BackgroundImage filename={filename} />)}

      {branch(filename, <Overlay />)}

      <Container>
        <Row>
          <Col
            lg={short ? 5 : 10}
            md={short ? 7 : 10}
            xs={10}
            xsOffset={1}
          >
            <Text.H1
              color={colors.brandPrimary}
              weight={600}
            >
              {title}
            </Text.H1>

            {branch(lead,
              <Text.H4 color={colors.white}>
                {lead}
              </Text.H4>
            )}
          </Col>
        </Row>
      </Container>
    </HeaderWrapper>
  );
}

/**
 * Export `Header`.
 */

export default compose(
  defaultProps({
    backgroundColor: colors.brandSecondary,
    short: false
  })
)(HeaderComponent);



// WEBPACK FOOTER //
// ../src/client/components/header/index.js